import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_icon = _resolveComponent("v-icon");
    return (_openBlock(), _createBlock(_component_v_icon, {
        color: $setup.typedProps.color,
        size: $setup.typedProps.size,
        start: $setup.typedProps.start,
        end: $setup.typedProps.end,
        icon: $setup.typedProps.icon,
        disabled: $setup.typedProps.disabled
    }, {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["color", "size", "start", "end", "icon", "disabled"]));
}
